import { VerificationStatus } from '@/entities/user'

export const convertVerificationStatus = (status: VerificationStatus) => {
  const { isVerified, isVerifying, notVerified } = {
    isVerified:
      status === VerificationStatus.CERTIFIED ||
      status === VerificationStatus.ID_VERIFIED,
    isVerifying:
      status === VerificationStatus.PENDING ||
      status === VerificationStatus.EMAIL_SENT ||
      status === VerificationStatus.HOLD,
    notVerified: status === VerificationStatus.NONE,
  }

  return { isVerified, isVerifying, notVerified }
}
